import type { ResourcesConfig } from 'aws-amplify'
import { type Environment, getEnvironment } from './utils/getEnvironment'

const REDIRECT_DOMAINS: Record<Environment, string> = {
  local: 'http://localhost:3000',
  development: 'https://driver-payr.app.dev.shipveho.com',
  staging: 'https://driver-payr.app.staging.shipveho.com',
  production: 'https://driver-payr.app.shipveho.com',
}

const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_USER_POOL_DOMAIN,
          scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [REDIRECT_DOMAINS[getEnvironment()]],
          redirectSignOut: [REDIRECT_DOMAINS[getEnvironment()]],
          responseType: 'code',
        },
      },
    },
  },
}

export default awsConfig
